export default {
  SET_CRITICAL_ERROR: '@YOLA_TEMPLATE_GALLERY/ERROR/SET_CRITICAL_ERROR',
  TRACK_ERROR: '@YOLA_TEMPLATE_GALLERY/ERROR/TRACK_ERROR',
};
